import { cmsPrefix } from "./constants";

export function getStacCollection() {
  return fetch(`${cmsPrefix}/cms_data/products`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((resp) => resp.json());
}